import $$ from 'dom7';
import Framework7 from 'framework7/framework7.esm.bundle.js';
// Import F7 Styles
import 'framework7/css/framework7.bundle.css';
// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';




var app = new Framework7({
    root: '#app', // App root element
    id: 'com.mdoc.app', // App bundle ID
    name: 'mDOC', // App name
    theme: 'auto', // Automatic theme detection
    pushState: true,
    panel: {
        swipe: 'left',
    },
    // App root data
    data: function () {
        return {
            user: {
                name: localStorage.getItem("name"),
                token: localStorage.getItem("token"),
                city: localStorage.getItem("city"), //================= default value is Ranchi
                avatar: localStorage.getItem("avatar_url") || '',
            },

            // remoteUrl: 'https://localhost/mdoc/api/api/app_v4_3_0/',
            // remoteBaseUrl: 'https://localhost/mdoc/api/',
            // assetsUrl: 'https://localhost/mdoc/api/api/appv3_0_1/', //new updated

            // remoteUrl: 'http://192.168.31.249/mdoc/api/api/app_v4_3_0/',
            // remoteBaseUrl: 'http://192.168.31.249/mdoc/api/',
            // assetsUrl: 'http://192.168.31.249/mdoc/api/api/appv3_0_1/', //new updated



            // remoteUrl: 'https://v2-mdoc.test/api/v5/',
            // remoteBaseUrl: 'https://v2-mdoc.test/',
            // assetsUrl: 'http://v2-mdoc.test/appv3_0_1/',

            // remoteUrl: 'http://192.168.29.177:8000/api/v5/',
            // remoteBaseUrl: 'http://192.168.29.177:8000/',
            // assetsUrl: 'http://192.168.29.177:8000/appv3_0_1/',

            // remoteUrl: 'https://v2.mdoc.in/api/v5/',
            // remoteBaseUrl: 'https://v2.mdoc.in/',
            // assetsUrl: 'http://v2.mdoc.test/appv3_0_1/',

            remoteUrl: 'https://v3.mdoc.in/api/v5/',
            remoteBaseUrl: 'https://v3.mdoc.in/',
            assetsUrl: 'http://v3.mdoc.test/appv3_0_1/',


            // Production URLs (uncomment for production)
            // remoteUrl: 'https://app.mdoc.in/api/v5/',
            // remoteBaseUrl: 'https://app.mdoc.in/',
            // assetsUrl: 'https://app.mdoc.in/appv3_0_1/',

        };
    },
    // App root methods
    methods: {
        helloWorld: function () {
            app.dialog.alert('Hello');
        },
        myAjax: function (formId, myPost, mySuccess, formDataPost) {

            if (formDataPost != 'undefine' || formDataPost != null) {
                var formData = app.form.convertToData(formId);
            } else {
                var formData = formId;
            }
            console.log("form data");
            console.log(formData);
            console.log(app.data.remoteUrl + myPost);
            app.request({
                url: app.data.remoteUrl + myPost,
                method: 'POST',
                data: { data: formData },
                statusCode: {
                    404: function (xhr) {
                        alert('page not found');
                    },
                },
                success: function (returndata) {
                    //console.log(returndata);
                    mySuccess(returndata);
                    console.log('Success');
                },
                complete: function () {
                    console.log('complete');
                    app.preloader.hide();
                },
                error: function (xhr) {
                    app.preloader.hide();
                    app.methods.requestError(xhr);
                    console.log('error');
                },
                beforeSend: function () {
                    app.preloader.show();
                    console.log('beforeSend');
                },
                //dataType: 'json',
            });
        },
        authHeader: function () {
            Framework7.request.setup({
                // beforeSend: function (xhr) {
                //     // xhr.setRequestHeader ('Authorization', 'Token '+ app.methods.localstoreout('token').access);
                //     xhr.setRequestHeader ('Authorization', 'Token ');
                // }
                headers: {
                    // 'Authorization', 'Token '+ app.methods.localstoreout('token').access
                    // 'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'mdoc-token': localStorage.getItem("token"),
                    'Accept': 'application/json'
                }
            });
        },
        // Maps an XHR failure to an accurate dialog. Use from any `error:` handler.
        // 401 is intentionally silent here — callers that care redirect to sign-in
        // via statusCode.401 or their own check; showing a dialog would duplicate.
        requestError: function (xhr) {
            var status = (xhr && xhr.status) || 0;
            if (status === 401) return;
            if (status === 0) {
                app.dialog.alert("Unable to connect. Please check your internet connection.", "Connection Error");
            } else if (status === 404) {
                app.dialog.alert("The requested resource was not found.", "Not Found");
            } else if (status >= 500) {
                app.dialog.alert("Server error. Please try again in a moment.", "Server Error");
            } else {
                app.dialog.alert("Something went wrong. Please try again.", "Error");
            }
        },
        createToken: function () {
            localStorage.setItem("token", "");
        },
        pageid: function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c === 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        // Home-page payload cache. 60s TTL, keyed by token+city. Used to skip
        // the preloader on rapid re-entry to /home/. Invalidated on logout
        // and after a booking is created.
        homeCacheKey: function () {
            var token = localStorage.getItem('token') || '';
            var city = localStorage.getItem('city') || '';
            // Use a short, stable fingerprint of the token (avoid storing the
            // full token in the cache key shape).
            var fp = token ? token.slice(0, 16) : '_';
            return 'homeCache::v1::' + fp + '::' + city;
        },
        getCachedHome: function () {
            try {
                var raw = localStorage.getItem(app.methods.homeCacheKey());
                if (!raw) return null;
                var parsed = JSON.parse(raw);
                if (!parsed || !parsed.t || !parsed.d) return null;
                if (Date.now() - parsed.t > 60 * 1000) return null;
                return parsed.d;
            } catch (e) {
                return null;
            }
        },
        setCachedHome: function (ctx) {
            try {
                localStorage.setItem(app.methods.homeCacheKey(), JSON.stringify({
                    t: Date.now(),
                    d: ctx
                }));
            } catch (e) { /* quota or disabled — ignore */ }
        },
        invalidateHomeCache: function () {
            try {
                var prefix = 'homeCache::v1::';
                for (var i = localStorage.length - 1; i >= 0; i--) {
                    var k = localStorage.key(i);
                    if (k && k.indexOf(prefix) === 0) localStorage.removeItem(k);
                }
            } catch (e) { /* ignore */ }
        },
        // Authenticated GET request - automatically includes mdoc-token header
        authGet: function (endpoint, successCallback, errorCallback) {
            app.methods.authHeader();
            app.preloader.show();
            app.request.json(app.data.remoteUrl + endpoint, function (data) {
                app.preloader.hide();
                if (data.status === false && data.msg && data.msg.toLowerCase().includes('unauthorized')) {
                    localStorage.setItem("token", "");
                    app.views.main.router.navigate('/sign_in/');
                    return;
                }
                if (successCallback) successCallback(data);
            }, function (xhr, status) {
                app.preloader.hide();
                if (xhr.status === 401) {
                    localStorage.setItem("token", "");
                    app.views.main.router.navigate('/sign_in/');
                    return;
                }
                if (errorCallback) {
                    errorCallback(xhr, status);
                } else {
                    app.methods.requestError(xhr);
                }
            });
        },
        // Native Razorpay Checkout using cordova plugin (supports UPI intent, Google Pay, PhonePe etc.)
        // paymentData: response.data from payments/initiate API
        // options: { onSuccess: fn, onDismiss: fn }
        razorpayCheckout: function (paymentData, options) {
            options = options || {};
            var isRazorpay = paymentData.gateway === 'razorpay';
            var isCordova = app.device.cordova;

            // Use native Razorpay plugin if available and gateway is razorpay
            if (isCordova && isRazorpay && typeof RazorpayCheckout !== 'undefined') {
                var rzpOptions = {
                    description: paymentData.description || 'mDOC Payment',
                    currency: paymentData.currency || 'INR',
                    key: paymentData.key_id,
                    amount: paymentData.amount_paise,
                    order_id: paymentData.order_id,
                    name: 'mDOC',
                    prefill: {
                        contact: localStorage.getItem("mobile") || '',
                        name: localStorage.getItem("name") || ''
                    },
                    theme: { color: '#e7364d' }
                };

                var paymentHandled = false;

                var successCallback = function (payment_id) {
                    if (paymentHandled) return;
                    paymentHandled = true;
                    // Verify payment on backend via server-to-server Razorpay API check
                    app.preloader.show();
                    var retryCount = 0;
                    var maxRetries = 3;

                    function verifyPayment() {
                        app.request({
                            url: app.data.remoteUrl + 'payments/verify-native',
                            method: 'POST',
                            data: {
                                razorpay_payment_id: payment_id,
                                razorpay_order_id: paymentData.order_id
                            },
                            dataType: 'json',
                            success: function () {
                                app.preloader.hide();
                                if (options.onSuccess) options.onSuccess(payment_id);
                            },
                            error: function () {
                                retryCount++;
                                if (retryCount < maxRetries) {
                                    // Retry after short delay - payment capture may still be processing
                                    setTimeout(verifyPayment, 2000);
                                } else {
                                    app.preloader.hide();
                                    // Payment was captured by Razorpay, webhook will handle it
                                    app.dialog.alert('Payment received. Your booking will be confirmed shortly.', 'mDOC', function() {
                                        if (options.onSuccess) options.onSuccess(payment_id);
                                    });
                                }
                            }
                        });
                    }

                    verifyPayment();
                };

                var cancelCallback = function (error) {
                    if (paymentHandled) return; // Payment already succeeded, ignore Razorpay SDK error
                    paymentHandled = true;
                    // error.code and error.description available
                    if (error && error.code !== 0) {
                        app.dialog.alert(error.description || 'Payment cancelled', 'Payment');
                    }
                    if (options.onDismiss) options.onDismiss();
                };

                RazorpayCheckout.open(rzpOptions, successCallback, cancelCallback);
            } else if (isCordova && paymentData.payment_url) {
                // Fallback: InAppBrowser for cashfree or if Razorpay plugin not available
                var ref = cordova.InAppBrowser.open(paymentData.payment_url, '_blank', 'location=yes,hideurlbar=yes,hidenavigationbuttons=yes,toolbarcolor=#ffffff,hardwareback=no,closebuttoncolor=#e7364d');
                ref.addEventListener('loadstop', function (event) {
                    app.preloader.hide();
                    if (event.url && event.url.indexOf('verify-redirect') > -1) {
                        setTimeout(function () { ref.close(); }, 2000);
                    }
                });
                ref.addEventListener('exit', function () {
                    if (options.onDismiss) options.onDismiss();
                });
            } else if (paymentData.payment_url) {
                // Web fallback
                window.open(paymentData.payment_url, '_blank');
            }
        },
        // Authenticated POST request - automatically includes mdoc-token header
        authPost: function (endpoint, data, successCallback, errorCallback) {
            app.methods.authHeader();
            app.preloader.show();
            app.request({
                url: app.data.remoteUrl + endpoint,
                method: 'POST',
                data: JSON.stringify(data),
                contentType: 'application/json',
                dataType: 'json',
                success: function (response) {
                    app.preloader.hide();
                    if (response.status === false && response.msg && response.msg.toLowerCase().includes('unauthorized')) {
                        localStorage.setItem("token", "");
                        app.views.main.router.navigate('/sign_in/');
                        return;
                    }
                    if (successCallback) successCallback(response);
                },
                error: function (xhr, status) {
                    app.preloader.hide();
                    if (xhr.status === 401) {
                        localStorage.setItem("token", "");
                        app.views.main.router.navigate('/sign_in/');
                        return;
                    }
                    if (errorCallback) {
                        errorCallback(xhr, status);
                    } else {
                        app.methods.requestError(xhr);
                    }
                }
            });
        },
    },
    // App routes
    routes: routes,
    // Register service worker
    serviceWorker: Framework7.device.cordova ? {} : {
        path: '/service-worker.js',
    },
    // Input settings
    input: {
        scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
        scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
    },
    // Cordova Statusbar settings
    statusbar: {
        overlay: Framework7.device.cordova && Framework7.device.ios || 'auto',
        iosOverlaysWebView: true,
        androidOverlaysWebView: false,
        androidBackgroundColor: '#ffffff',
        androidTextColor: 'black'
    },
    on: {
        init: function () {
            var f7 = this;
            if (f7.device.cordova) {
                // Init cordova APIs (see cordova-app.js)
                cordovaApp.init(f7);
            }

        },
    },
});
/*
 -- All common function will goes here ---
 */

function updateDate(e) {
    console.log(e);
}



//================on home page update=============================
var mainView = app.views.create('.view-main', {
    url: '/home/',
});
//============== call onload function ==========
function onLoad() {
    document.addEventListener("deviceready", onDeviceReady, false);
}

//------------ call on device ready -----------
function onDeviceReady() {
    //============= call login UI =============
    saveToken = localStorage.getItem("token");
    if (saveToken == null || saveToken == '') {
        localStorage.setItem("token", "");
        app.loginScreen.open('#my-login-screen');
    } else {
        app.data.token = saveToken;
        app.data.user.name = localStorage.getItem("name");
    }
    // console.log('jit');
    // console.log(device);
    var deviceDetails = JSON.stringify(device);
    // console.log(deviceDetails);
    // console.log('sri')

    //    city = localStorage.getItem("city");
    //    if (city == null || city == '') {
    //        localStorage.setItem("city", "1");
    //    } else {
    //        var ss = app.smartSelect.get('#homePage .smart-select');
    //        ss.setValue(city);
    //
    //    }

    //    console.log(app);
    updateTodayDate();
}
//=================== success Function =====================
//------------------- This is default function
function mySuccess(returnData) {
    // console.log(returnData);
    returnData = JSON.parse(returnData);
    if (returnData['status']) {
        app.dialog.alert(returnData['msg']);
    } else {
        app.dialog.alert(returnData['msg']);
        logout();
    }
}

//------------------- This function is for after login success
function loginSuccess(returnData) {
    //cosole.log("jit login");
    returnData = JSON.parse(returnData);
    if (returnData['status']) {
        storeSession(returnData);
        //app.dialog.alert(returnData['msg']);
        // app.loginScreen.close('#my-login-screen');
    } else {
        app.dialog.alert(returnData['msg']);
    }
}
//-------------------  after registration success --------------------
function registrationSuccess(returnData) {
    returnData = JSON.parse(returnData);
    if (returnData['status']) {
        storeSession(returnData);
        app.dialog.alert(returnData['msg'], "THANK YOU !!");
        app.views.main.router.navigate('/home/');
        app.views.main.router.clearPreviousHistory();
    } else {
        app.dialog.alert(returnData['msg']);
    }
}
// //-------------------  after booking success --------------------
// function bookingSuccess(returnData) {
//     returnData = JSON.parse(returnData);
//     if (returnData['status']) {
//         payment(returnData['book_id']);
//         //app.dialog.alert(returnData['msg'], "THANK YOU !!");
//         //        app.views.main.router.navigate('/paymentSuccess/');
//         app.views.main.router.navigate('/appointment/');
//         app.views.main.router.clearPreviousHistory();
//     } else {
//         app.dialog.alert(returnData['msg']);
//     }
// }

//================= logout ============
function logout() {
    //====================== update global variable ==============
    app.data.token = '';
    app.data.user.name = '';
    // Call logout API with auth header
    app.methods.authHeader();
    app.request({
        url: app.data.remoteUrl + 'auth/logout',
        method: 'POST',
        dataType: 'json',
        success: function (data) {
            console.log('Logout successful');
        },
        error: function () {
            console.log('Logout API error');
        }
    });
    //============= remove from local storage =========
    localStorage.setItem("name", "");
    localStorage.setItem("token", "");
    localStorage.removeItem("avatar_url");
    app.data.user.avatar = '';
    app.methods.invalidateHomeCache();
    app.views.main.router.navigate('/sign_in/');
    app.views.main.router.clearPreviousHistory();
}

//================= comming soon ===============
function comingSoon() {
    app.dialog.alert("Coming Soon");
}
function updateTodayDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    var today = yyyy + '/' + mm + '/' + dd;
    app.data.today = today;
    console.log(app.data.today);
}

/*
 *  --  End common function --
 *
 */

/*
 * -- All event will goes here --
 * -- strat -
 */



//================================ feedback form submit ==============
$$(document).on('submit', '#feedbackForm', function (e) {
    e.preventDefault();
    var formData = app.form.convertToData('#feedbackForm');

    if (!formData.name || !formData.message) {
        app.toast.create({ text: 'Please enter your name and message', closeTimeout: 2000 }).open();
        return;
    }

    app.methods.authHeader();
    app.preloader.show();
    app.request({
        url: app.data.remoteUrl + 'feedback',
        method: 'POST',
        data: formData,
        dataType: 'json',
        success: function (resp) {
            app.preloader.hide();
            if (resp && resp.status) {
                app.toast.create({ text: resp.msg || 'Thanks for your feedback!', closeTimeout: 2500 }).open();
                $$('#feedbackForm')[0].reset();
            } else {
                app.dialog.alert((resp && resp.msg) || 'Could not submit feedback', 'Error');
            }
        },
        error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
        },
    });
});

//================================ Ask Care AI (static for now) ==============
$$(document).on('click', '#askCareAiBtn', function (e) {
    e.preventDefault();
    app.dialog.alert('Care AI is coming soon. You\'ll be able to chat with our AI assistant right from here.', 'Ask Care AI');
});

//================================ login form submit ==============
$$(document).on('submit', '#loginForm', function (e) {
    e.preventDefault();
    console.log("jitlogin");
    app.methods.myAjax('#loginForm', 'login', loginSuccess);
});
//================================ login ==============
$$(document).on('click', '.logout', function (e) {
    logout();
});
//================================ Registration form submit ==============
$$(document).on('submit', '#signUpForm', function (e) {
    e.preventDefault();
    var formData = app.form.convertToData('#signUpForm');

    // Validate passwords match (only if password provided)
    if (formData.password1 && formData.password1 !== formData.password2) {
        app.toast.create({
            text: 'Password not match!!',
            position: 'center',
            closeTimeout: 2000,
        }).open();
        return;
    }

    // Prepare registration data for new API
    var registerData = {
        mobile: formData.mobile,
        name: formData.name,
        email: formData.email || '',
        address: formData.address || '',
        password: formData.password1 || ''
    };

    app.preloader.show();
    app.request({
        url: app.data.remoteUrl + 'auth/register',
        method: 'POST',
        data: JSON.stringify(registerData),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            app.preloader.hide();
            console.log(data);
            if (data.status && data.token) {
                // Registration successful - save token and go to home
                localStorage.setItem("token", data.token);
                localStorage.setItem("name", data.name || formData.name);
                localStorage.setItem("mobile", data.mobile || formData.mobile);
                var city = localStorage.getItem("city");
                if (city == null || city == '') {
                    localStorage.setItem("city", "1");
                }
                $$('#loginUserName').text(data.name || formData.name);
                app.dialog.alert(data.msg || 'Registration successful', "Welcome!");
                app.views.main.router.navigate('/home/');
                app.views.main.router.clearPreviousHistory();
            } else {
                app.dialog.alert(data.msg || 'Registration failed', "Registration Failed");
            }
        },
        error: function(xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
        }
    });
});
//================================ change password form submit ==============
$$(document).on('submit', '#chnagePassForm', function (e) {
    e.preventDefault();
    var validation = false;
    var formData = app.form.convertToData('#chnagePassForm');
    if (formData.password1 != formData.password2) {
        var toastBottom = app.toast.create({
            text: 'Password not match!!',
            position: 'center',
            closeTimeout: 2000,
        });
        toastBottom.open();
        validation = false;
    } else {
        validation = true;
        app.methods.authPost('auth/change-password', {
            old_password: formData.old_password,
            password: formData.password1,
            password_confirmation: formData.password2
        }, function (response) {
            if (response.status) {
                app.dialog.alert(response.msg, "Success");
            } else {
                app.dialog.alert(response.msg);
            }
        });
    }
    console.log(formData);
});
//==================== Login Screen Demo =================
$$('#my-login-screen .login-button').on('click', function () {
    var username = $$('#my-login-screen [name="username"]').val();
    var password = $$('#my-login-screen [name="password"]').val();
    // Close login screen
    app.loginScreen.close('#my-login-screen');
    // Alert username and password
    app.dialog.alert('Username: ' + username + '<br>Password: ' + password);
});
//================================ Edit Profile form submit ==============
$$(document).on('submit', '#editProfileForm', function (e) {
    e.preventDefault();
    var formData = app.form.convertToData('#editProfileForm');
    console.log(formData['name']);
    app.methods.authPost('user/profile', formData, function (response) {
        if (response.status) {
            var name = response.data ? response.data.name : response.name;
            app.data.user.name = name;
            $$('#loginUserName').text(name);
            localStorage.setItem("name", name);
            app.dialog.alert(response.msg, "Profile Updated");
        } else {
            app.dialog.alert(response.msg);
        }
    });
});
//==================== Login Screen Demo ===================
$$('.comingSoon').on('click', function () {
    console.log("coming soon");
    app.dialog.alert("Coming Soon");
});

//=============== Search Bar ==============
//var searchbar = app.searchbar.create({
//    el: '.doctoreSearchbar',
//    searchContainer: '.doctorList',
//    searchIn: '.dr-name',
//    searchItem: '.doctor',
//    on: {
//        search(sb, query, previousQuery) {
//            console.log(query, previousQuery);
//        }
//    }
//});


//document.addEventListener("deviceready", onDeviceReady11, false);
//function onDeviceReady11() {
//
//
//
//}


$$(document).on('click', '#couponApplyAfter .rmv_btn', function (e) {
    punoMushikoBhawa();
});

// ====== "Why verified?" partner doctor info popup ======
$$(document).on('click', '.partner-info-btn', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var body =
        '<div class="partner-info-body">' +
            '<p style="margin:0 0 10px;font-size:13px;color:var(--mdoc-ink);line-height:1.5;">' +
                'Partner doctors are personally onboarded and verified by the mDOC team.' +
            '</p>' +
            '<ul style="margin:0;padding:0;list-style:none;font-size:13px;color:var(--mdoc-ink);line-height:1.6;">' +
                '<li style="display:flex;align-items:flex-start;gap:8px;margin-bottom:8px;">' +
                    '<i class="icon f7-icons if-not-md" style="color:var(--mdoc-green);font-size:16px;margin-top:1px;">checkmark_alt_circle_fill</i>' +
                    '<i class="icon material-icons md-only" style="color:var(--mdoc-green);font-size:16px;margin-top:1px;">check_circle</i>' +
                    '<span>Verified credentials and experience</span>' +
                '</li>' +
                '<li style="display:flex;align-items:flex-start;gap:8px;margin-bottom:8px;">' +
                    '<i class="icon f7-icons if-not-md" style="color:var(--mdoc-green);font-size:16px;margin-top:1px;">checkmark_alt_circle_fill</i>' +
                    '<i class="icon material-icons md-only" style="color:var(--mdoc-green);font-size:16px;margin-top:1px;">check_circle</i>' +
                    '<span>Subscription discounts available</span>' +
                '</li>' +
                '<li style="display:flex;align-items:flex-start;gap:8px;margin-bottom:8px;">' +
                    '<i class="icon f7-icons if-not-md" style="color:var(--mdoc-green);font-size:16px;margin-top:1px;">checkmark_alt_circle_fill</i>' +
                    '<i class="icon material-icons md-only" style="color:var(--mdoc-green);font-size:16px;margin-top:1px;">check_circle</i>' +
                    '<span>Priority booking confirmation</span>' +
                '</li>' +
                '<li style="display:flex;align-items:flex-start;gap:8px;">' +
                    '<i class="icon f7-icons if-not-md" style="color:var(--mdoc-green);font-size:16px;margin-top:1px;">checkmark_alt_circle_fill</i>' +
                    '<i class="icon material-icons md-only" style="color:var(--mdoc-green);font-size:16px;margin-top:1px;">check_circle</i>' +
                    '<span>Curated by the mDOC team</span>' +
                '</li>' +
            '</ul>' +
        '</div>';
    app.dialog.create({
        title: 'mDOC Verified Partner',
        text: body,
        buttons: [{ text: 'Got it', bold: true }]
    }).open();
});




/*
 *  -- End event --
 */

//======================== booking form page ========================================
$$(document).on('page:init', '.page[data-name="booking_form_"]', function (e, page) {
    var $page = $$(page.el);

    var toastBottom = app.toast.create({
        text: 'Doctor Not Available !!',
        position: 'center',
        closeTimeout: 2000,
    });
    //========= date click =============
    $page.on('click', '.dateBtn', function (e) {
        if ($$(this).hasClass('inactive')) {
            $page.find('.dateBtn').removeClass('active');
            $page.find('#slotTimeArea').html("");
            $page.find('#doctorBookingDate').val("");
            toastBottom.open();
        } else {
            $page.find('.dateBtn').removeClass('active');
            $$(this).addClass('active');
            var day = $$(this).data("myday");
            var fullDate = $$(this).data("fullDate");
            var doctor = page.route.context.data.id;
            $page.find('#doctorBookingDate').val(fullDate);
            console.log(app.data.remoteUrl + 'getDoctorTime/' + doctor + '/' + day + '/');
            app.request({
                url: app.data.remoteUrl + 'getDoctorTime/' + doctor + '/' + day + '/',
                method: 'POST',
                success: function (returndata) {
                    console.log(returndata);
                    $page.find('#slotTimeArea').html(returndata);
                },
                complete: function () {
                    app.preloader.hide();
                },
                error: function (xhr) {
                    app.preloader.hide();
                    app.methods.requestError(xhr);
                },
                beforeSend: function () {
                    app.preloader.show();
                },
            });
        }
    });
    //============= Time slot click ==================
    $page.on('click', '.slotTimeSection', function (e) {
        if ($$(this).hasClass('active')) {
            $page.find('#doctorBookingTime').val('');
            var doctorBookingTime = $$(this).text();
            $page.find('#doctorBookingTime').val(doctorBookingTime);
        } else {
            $page.find('.slotTimeSection').removeClass('active');
            $$(this).addClass('active');
            var doctorBookingTime = $$(this).html();
            $page.find('#doctorBookingTime').val(doctorBookingTime);
        }
    });
});
//======================== doctore prebook not available =================
$$(document).on('click', '#DoctorListPage .doc_btn_disable', function (e) {
    app.dialog.alert("Booking will start soon !!", " ");
});
//======================== login details ==================================
$$(document).on('page:init', '.page[data-name="sign_in"]', function (e, page) {

    //    var saveToken = localStorage.getItem("token");
    //    console.log("token - " + saveToken);


    //================================ Mobile Number Submit ==============
    //    $$(document).on('submit', '#enterMobileForm', function (e) {
    //        e.preventDefault();
    ////    app.methods.myAjax('#loginForm', 'login', loginSuccess);
    //    });

});
//======================== doctor prebook not available =================
$$(document).on('click', '#appoitmentBillPage .printBill', function (e) {
    var appId = $$(this).data("appid");
    //    app.dialog.alert("Booking will start soon !!", appId);

    var url = app.data.remoteUrl + 'printBill/' + appId + '/';
    var url = "file:///home/biswa/Downloads/mDOC1574760127.pdf";
    console.log(url);
    //    var fileTransfer = new FileTransfer();
    //    var uri = encodeURI(url), fileURL = '/var/www/html/mdoc';
    //
    //    fileTransfer.download(
    //            uri,
    //            fileURL,
    //            function (entry) {
    //                console.log("download complete: " + entry.toURL());
    //            },
    //            function (error) {
    //                console.log("download error source " + error.source);
    //                console.log("download error target " + error.target);
    //                console.log("download error code" + error.code);
    //            },
    //            false,
    ////            {
    ////                headers: {
    ////                    "Authorization": "Basic dGVzdHVzZXJuYW1lOnRlc3RwYXNzd29yZA=="
    ////                }
    ////            }
    //            );




    downloader.init();
    downloader.get(url);
});
//======================== chanage city  ================================
$$(document).on('change', '#selectCity', function (e) {
    var city = [];
    var ss = app.smartSelect.get('.smart-select');
    city['id'] = ss.getValue();
    //    //------------------ update city value -------------
    updateCity(city);
    app.views.main.router.navigate('/home/');
    app.views.main.router.clearPreviousHistory();
});

$$(document).on('click', '#DoctorListPage .comingSoon', function (e) {
    comingSoon();
});
$$(document).on('click', '#enpBooking .comingSoon', function (e) {
    comingSoon();
});

$$(document).on('click', '#copyCoupon', function (e) {
    var text = $$(this).data("code");
    cordova.plugins.clipboard.copy(text);
});

$$(document).on('click', '#myCouponList .copyCoupun', function (e) {
    var text = $$(this).data("code");
    //    console.log(text);
    cordova.plugins.clipboard.copy(text);
});

///============== whatapp share ============
$$(document).on('click', '#whatsAppShare', function (e) {
    var text = $$(this).data("code");
    window.plugins.socialsharing.shareViaWhatsApp(text, null /* img */, null /* url */,
        function () {
            console.log('share ok')
        },
        function (errormsg) {
            console.log(errormsg)
        });
});
$$(document).on('click', '#faceBookShare', function (e) {
    var text = $$(this).data("code");
    window.plugins.socialsharing.shareViaFacebook(text, null /* img */, null /* url */,
        function () {
            console.log('share ok')
        },
        function (errormsg) {
            console.log(errormsg)
        }
    );


});
$$(document).on('click', '#instaShare', function (e) {
    var text = $$(this).data("code");
    window.plugins.socialsharing.share(text);

});
$$(document).on('click', '#anyShare', function (e) {
    var text = $$(this).data("code");
    window.plugins.socialsharing.share(text);
});
//=========================================


function enterMobile(data) {
    console.log(data);
}

function storeSession(returnData) {
    app.data.token = returnData['token'];
    app.data.user.name = returnData['name'];
    app.data.user.city = '1';  //==== default city is Ranchi ========
    $$('#loginUserName').text(returnData['name']);
    localStorage.setItem("token", returnData['token']);
    localStorage.setItem("name", returnData['name']);
    // localStorage.setItem("mobile", returnData['name']);
    localStorage.setItem("city", "1");
}

function destroySession() {

}

// function payment(bookId) {
//     var token = localStorage.getItem("token");
//     var url = app.data.remoteUrl + 'paynow/' + token + '/' + bookId + '/';
//     if (app.device.cordova) {
//         app.preloader.show();
//         var ref = cordova.InAppBrowser.open(url, '_blank', 'location=yes,hideurlbar=yes,hidenavigationbuttons=yes,toolbarcolor=#ffffff,hardwareback=no,closebuttoncolor=#e7364d');
//         ref.addEventListener("loadstop", function () {
//             app.preloader.hide();
//         });
//     } else {
//         window.open(url, "_blank");
//     }
// }

function updateCity(city) {
    //console.log(city);
    //app.data.city_name = city['name'];
    app.data.user.city = city['id'];
    //localStorage.setItem("city_name", city['name']);
    localStorage.setItem("city", city['id']);
}


function downloadBill(bookId) {

    var url = app.data.remoteUrl + 'printBill/' + bookId + '/';
    if (app.device.cordova) {
        app.preloader.show();
        var ref = cordova.InAppBrowser.open(url, '_blank', 'location=yes,hideurlbar=yes,hidenavigationbuttons=yes,toolbarcolor=#ffffff,hardwareback=no,closebuttoncolor=#e7364d');
        ref.addEventListener("loadstop", function () {
            app.preloader.hide();
        });
    } else {
        window.open(url, "_blank");
    }
}

$$(document).on('click', '#goToLive', function (e) {
    console.log("go live");
    if (app.device.cordova) {
        var ref = cordova.InAppBrowser.open(app.data.paymentUrl, '_self', 'location=no');
    } else {
        window, open(app.data.paymentUrl, "_blank");
    }
    console.log("live hogeya");
});

function punoMushikoBhawa() {
    //=============== update coupon =====================
    $$('#bookingCoupon').val("");
    //=============== update coupon number ==============
    $$('#couponApplyBefor').show();
    $$('#couponApplyAfter').hide();
    //--------------------- update doctor fee calculation ----------------
    var dscnt_amt = $$('#amntdetail .dscnt_amt').data("dscnt_amt");
    var gstAmount = $$('#amntdetail .gstAmount').data("gstAmount");
    var totalAmnt = $$('#amntdetail .totalAmnt').data("totalAmnt");
    $$('#amntdetail .dscnt_amt').text(dscnt_amt);
    $$('#amntdetail .gstAmount').text(gstAmount);
    $$('#amntdetail .totalAmnt').text(totalAmnt);
}